<template>
  <v-app id="app">
    <AppBar v-show="this.$route.name !== 'loading'"></AppBar>
    <Drawer v-show="this.$route.name !== 'loading'"></Drawer>
    <Content></Content>
    <Footer v-show="this.$route.name !== 'loading'"></Footer>
  </v-app>
</template>

<script>
import AppBar from "./components/appbar/AppBar";
import Content from "./components/Content";
import Footer from "./components/Footer";
import Drawer from "./components/drawer/Drawer";
export default {
  name: "PortalIndex",
  components: {
    Drawer,
    Footer,
    Content,
    AppBar
  }
};
</script>

<style scoped></style>
